<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
      class="add-new-data-sidebar items-no-padding" spacer v-esc="escape" v-model="isSidebarActiveLocal">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "Yeni Yasaklı Kullanıcı" : "Yasaklı Kullanıcı Düzenle" }}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>
      <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
        <form data-vv-scope="form-1" @keyup.enter="submitData">
          <div class="flex mt-5 px-6 pb-4">
              <vs-radio v-model="newBlackList.type" class="mr-auto" vs-value="0">Email</vs-radio>
              <vs-radio class="ml-auto" color="success" v-model="newBlackList.type" vs-value="1">Telefon</vs-radio>
          </div>
          <div class="px-6">
  
            <div v-show="newBlackList.type == 0">
        <vs-input name="Email" v-validate="'required|min:2|max:40|email'" v-model="newBlackList.email" class="w-full" icon-pack="feather" icon="icon-mail" label-placeholder="Email" />
        <span class="text-danger text-sm" v-show="errors.has('form-1.Email')">{{ errors.first('form-1.Email')}}</span>
      </div>

      <div v-show="newBlackList.type == 1">
        <!-- Replace the validation rules with the appropriate ones for a phone number -->
        <vs-input v-mask="phoneMask" name="Telefon" v-validate="'required|min:13|max:13|'" v-model="newBlackList.phone" class="w-full"  icon-pack="feather" icon="icon-phone" label-placeholder="Telefon" />
        <span class="text-danger text-sm" v-show="errors.has('form-1.Telefon')">Telefon 10 haneli olmalıdır.</span>
      </div>
  
          </div>
        </form>
        <div class="flex mt-5 px-6 pb-4">
          <vs-button class="mr-auto" type="gradient" color="danger" @click="isSidebarActiveLocal = false">
            Vazgeç
          </vs-button>
          <vs-button class="ml-auto" color="success" @click="submitData">Kaydet</vs-button>
        </div>
      </VuePerfectScrollbar>
    </vs-sidebar>
  </template>
  
  <script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import {
        createBlackList,
        updateBlackList,
    } from '@/api/BlackList';
    export default {
      props: {
        isSidebarActive: {
          type: Boolean,
          required: true
        },
        data: {
          type: Object,
          default: () => {},
        }
      },
      data() {
  
        return {
          phoneMask: "### ### ## ##",
          newBlackList: {type:0,phone:'',email:''},
          settings: { // perfectscrollbar settings
            maxScrollbarLength: 60,
            wheelSpeed: .60,
          },
        }
      },
      computed: {
        isSidebarActiveLocal: {
          get() {
            return this.isSidebarActive
          },
          set(val) {
            if (!val) {
              this.$emit('closeSidebar')
              this.$validator.reset()
              this.initValues()
            }
          }
        }
      },
      methods: {
        setType(type){
          this.newBlackList.type = type;
        },
        escape(){
          if(this.isSidebarActiveLocal = true) this.isSidebarActiveLocal = false;
        },
        initValues() {
          this.newBlackList = {id : 0,phone:'',email:'',value:''};
        },
        submitData: async function () {
          this.newBlackList.type = parseInt(this.newBlackList.type);
          let checker;
          if(this.newBlackList.type == 0){
            this.newBlackList.value = this.newBlackList.email;
            checker = await this.$validator.validate('form-1.Email');
          }else{
            checker = await this.$validator.validate('form-1.Telefon');
            this.newBlackList.value = this.newBlackList.phone.replace(/\s/g, '');
          }
          
          if (checker) {
            if (this.newBlackList.id) {
              updateBlackList(this.newBlackList).then(res => {
                if (res && res.status == 200) {
                  this.$store.dispatch("blackList/updateBlackList", res.data).then(data => {
                    this.$vs.notify({
                      color: 'success',
                      title: 'Başarılı !',
                      text: 'Yasaklı Kullanıcı Güncelleme Başarılı ! '
                    });
                    this.$emit('closeSidebar');
                    this.initValues();
                    this.$validator.reset();
                  });
                } else {
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Hata : ' + res.status,
                    text: 'Yasaklı Kullanıcı Güncelleme Başarısız ! '
                  });
                }
              }).catch((error) => {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata !',
                  text: error.response.data.Errors[0].Message
                });
              });
            } else {
              this.newBlackList.id = 0;
              createBlackList(this.newBlackList).then(res => {
                if (res && res.status == 200) {
                  this.$store.dispatch("blackList/addBlackList", res.data).then(data => {
                    this.$vs.notify({
                      color: 'success',
                      title: 'Başarılı !',
                      text: 'Yasaklı Kullanıcı Ekleme Başarılı ! '
                    });
                    this.$emit('closeSidebar');
                    this.initValues();
                    this.$validator.reset();
                  });
                } else {
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Hata !',
                    text: 'Yasaklı Kullanıcı Ekleme Başarısız ! '
                  });
                }
              }).catch((error) => {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata !',
                  text: error.response.data.Errors[0].Message
                });
              });
            }
          }
        },
      },
      components: {
        VuePerfectScrollbar
      },
      watch: {
        'newBlackList.phone': {
    handler(newPhone) {
      if (newPhone.substring(0, 1) === '0') {
        this.$set(this.newBlackList, 'phone', newPhone.substring(1));
      }
    },
    deep: true
  },
  'newBlackList.type': {
    handler(newPhone) {
    },
    deep: true
  },
        isSidebarActive: function (val) {
          if (!val) return
          if (Object.entries(this.data).length === 0) {
            this.initValues();
            this.$validator.reset();
          } else {
            this.newBlackList = { type:0};
            this.newBlackList = _.cloneDeep(this.data);
          }
        },
      },
      mounted: function () {},
      created: async function () {}
    }
  
  </script>
  
  <style lang="scss" scoped>
    .style-chooser .vs__dropdown-menu {
      background: #dfe5fb;
      border: none;
      color: red;
      text-transform: lowercase;
      font-variant: small-caps;
    }
  
    .add-new-data-sidebar {
      ::v-deep .vs-sidebar--background {
        z-index: 52010;
      }
  
      ::v-deep .vs-sidebar {
        z-index: 52010;
        width: 400px;
        max-width: 90vw;
  
        .img-upload {
          margin-top: 2rem;
  
          .con-img-upload {
            padding: 0;
          }
  
          .con-input-upload {
            width: 100%;
            margin: 0;
          }
        }
      }
    }
  
    .tabPager {
      background-color: darkgreen;
      border-radius: 50%;
    }
  
  </style>
  
  <style>
  .vs__dropdown-menu {
      max-height: 25vh !important;
      overflow-x: hidden !important;
      overflow-y: scroll !important;
    }
  </style>
  